import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

/**
 * The quantity field of one movement line (CHG-2026-09-stock-usage-and-price-twins, D9).
 *
 * One and the same `<input>` for both counting modes: when the picked article turns out to count
 * partial amounts, only its attributes change (text + decimal keyboard instead of number), so a
 * field the user is typing in keeps its focus. A whole-number article gets exactly the field the
 * modal always rendered.
 */
export function MovementQuantityInput({
  inputRef,
  value,
  onChange,
  onKeyDown,
  placeholder,
  disabled,
  fractional,
  unit,
}: {
  inputRef: (el: HTMLInputElement | null) => void
  value: string
  onChange: (value: string) => void
  onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void
  placeholder: string
  disabled: boolean
  fractional: boolean
  unit?: string
}) {
  return (
    <div className={cn('col-span-2', fractional && 'flex items-center gap-1')}>
      <Input
        ref={inputRef}
        // "Teilmengen zählen": a text field keeps the de-AT comma a number field drops.
        type={fractional ? 'text' : 'number'}
        inputMode={fractional ? 'decimal' : 'numeric'}
        autoComplete={fractional ? 'off' : undefined}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        disabled={disabled}
      />
      {fractional && unit ? (
        <span className="shrink-0 text-xs text-muted-foreground">{unit}</span>
      ) : null}
    </div>
  )
}
